<!-- 拣货商品明细 -->
<template>
  <div class="page-content">
    <c-header pageName="拣货商品明细"></c-header>
    <div class="band-info flex">
      <section>库位 : {{info.slCode}}</section>
    </div>
<!--    <div class="search flex" v-show="!isSearchBarCode">-->
<!--      <van-field v-model="bandSn" autofocus />-->
<!--      <section @click="onSearchBan">扫描板号</section>-->
<!--    </div>-->
<!--    <div class="search flex" v-show="isSearchBarCode">-->
<!--      <van-field v-model="barCode" autofocus />-->
<!--      <section @click="onSearchBarCode">扫描国际码</section>-->
<!--    </div>-->
    <div class="search flex">
      <van-field v-model="barCode" autofocus />
      <section @click="onSearchBarCode">扫描国际码</section>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="picking-item flex" v-for="(item,index) in pickDetails" :key="index">
        <div class="item-content">
          <section>库位 : {{item.slCode}}</section>
<!--          <section>板号 : {{item.bandSn}}</section>-->
          <section>商品名称 : {{item.productName}}</section>
          <section>国际条码 : {{item.barCode}}</section>
          <section>
            待拣数量 :
            <span class="span-unpick">&nbsp;{{item.qty-item.pickQty}}</span>
          </section>
          <section>
            已拣数量 :
            <span class="span-picked">&nbsp;{{item.pickQty}}</span>
          </section>
          <section v-if="item.pickQty===0">
            拣货状态 :
            <span class="span-unpick">&nbsp;未拣货</span>
          </section>
          <section v-else-if="item.pickQty!==item.qty">
            拣货状态 :
            <span class="span-picking">&nbsp;拣货中</span>
          </section>
          <section v-else-if="item.pickQty===item.qty">
            拣货状态 :
            <span class="span-picked">&nbsp;已拣货</span>
          </section>
        </div>
      </div>
    </van-list>
    <c-pickDetail
      :show="pickDetailsShow"
      @closeDialog="closePickDetailDialog"
      :info="pickDetailInfo"
      @pickEventSuccess="pickEventSuccess"
    ></c-pickDetail>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import PickDetailDialog from "../components/pickDetailDialog.vue";
export default {
  data() {
    return {
      info: {},
      bandSn: "",
      barCode: "",
      isSearchBarCode: false, // 是否为搜索国际码
      pickOrderInfo: {}, // 拣货明细单详情
      currentPage: 1,
      pageSize: 10,
      loading: false,
      finished: true,
      pickDetails: [], // 拣货明细列表
      pickDetailsShow: false, //拣货明细弹框
      pickDetailInfo: {},
      timer: null
    };
  },
  components: {
    "c-header": Header,
    "c-pickDetail": PickDetailDialog
  },
  mounted() {
    this.info = this.$route.query.info;
    this.getPickDetails();
  },
  methods: {
    getPickDetails() {
      let param = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        pickingOrderId: this.info.pickingOrderId,
        slId: this.info.slId
      };

      this.$post(this.URL.getPickingGoodsDetailList, param).then(res => {
        if (res.success) {
          this.pickDetails = [...this.pickDetails, ...res.data.records];
          if (res.data.totalPage > this.currentPage) {
            this.finished = false;
          } else {
            this.finished = true;
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getPickDetails();
      }
    },
    // 扫描版号
    onSearchBan() {
      this.isSearchBarCode = true;
    },
    // 扫描国际码
    onSearchBarCode() {
      let param = {
        slId: this.info.slId,
        slCode: this.info.slCode,
        pickingOrderId: this.info.pickingOrderId,
        bandSn: this.bandSn,
        barCode: this.barCode
      };
      this.$post(this.URL.padScanPicking, param).then(res => {
        if (res.success) {
          this.onShowPickDetailDialog(res.data);
        } else {
          this.$toast.fail(res.message);
         // this.isSearchBarCode = false;
        }
      });
    },
    // 显示拣货明细弹框
    onShowPickDetailDialog(data) {
      this.pickDetailsShow = true;
      this.pickDetailInfo = data;
    },
    // 关闭拣货明细弹框
    closePickDetailDialog() {
      this.bandSn = "";
      this.barCode = "";
      this.isSearchBarCode = false;
      this.pickDetailsShow = false;
    },
    // 拣货成功，切换
    pickEventSuccess() {
      this.currentPage = 1;
      this.pickDetails = [];
      this.getPickDetails();
      this.verifyIsPickComplete();
    },
    //校验拣货明细是否拣货完成
    verifyIsPickComplete() {
      let param = {
        id: this.info.pickingOrderId,
        bizId: this.info.slId,
        intValue: 1
      };

      this.$post(this.URL.verifyPickingCart, param).then(res => {
        if (res.success) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$dialog
            .alert({
              title: "拣货提示",
              message: "当前库位已拣货完成"
            })
            .then(() => {
              this.$router.push({
                path: "/pickingDetail",
                query: {
                  pickingId: res.data.id,
                  pickOrderSn: res.data.sn,
                  pickCarCode: res.data.carCode,
                  status: res.data.status
                }
              });
            });
          }, 1000);
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.band-info {
  height: 3rem;
  align-items: center;
  padding: 0 1rem;
  font-size: 0.9rem;
  color: #444;
}
.search {
  margin: 0 1rem;
  align-items: center;
  height: 2.2rem;
  border: 1px solid #f0f0f0;
  border-radius: 0.2rem;
  .van-cell {
    display: inline-flex;
    align-items: center;
    height: 2rem;
    width: 70%;
    background-color: white;
  }
  section {
    height: 2rem;
    align-items: center;
    border-left: 1px solid #f0f0f0;
    font-size: 0.9rem;
    display: inline-flex;
    width: 30%;
    justify-content: center;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
}
.goods-info {
  font-size: 0.85rem;
  padding: 1rem;
  color: #444;
  section {
    display: flex;
    width: 100%;
    padding: 0.3rem 0;
    label {
      display: inline-flex;
      align-items: center;
    }
    label:first-child {
      width: 5rem;
    }
  }
}
.has-order {
  height: 18rem;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  section {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 0.8rem;
    height: 3rem;
    padding-left: 1rem;
    align-content: center;
    border-bottom: 1px dashed #f0f0f0;
    span {
      display: flex;
      width: 100%;
    }
  }
}
.picking-sub {
  font-size: 0.85rem;
  color: #fff;
  height: 2rem;
  justify-content: center;
  margin-top: 1rem;
  section {
    display: inline-flex;
    width: 18rem;
    background-color: #dc6350;
    height: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.3rem;
  }
}
.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;
  .picking-item {
    padding: 0.5rem 0;
    border-bottom: 1px dashed #eee;
    .item-content {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
      section {
        display: flex;
        width: 100%;
        line-height: 1.2rem;
        label {
          display: inline-flex;
        }
        label:first-child {
          width: 5rem;
        }
      }
    }
    .item-icon {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: flex-end;
      i {
        font-size: 1.5rem;
        color: #dc6350;
      }
    }
  }
  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
.span-unpick {
  color: red;
}
.span-picking {
  color: darkorange;
}
.span-picked {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/pages/PickingGoodsDetail.vue